// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lc-am-html[data-v-5ef47038]{position:relative;min-height:20px;box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
